document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') {
    console.error('Swiper no está cargado (Swiper undefined).');
    return;
  }

  document.querySelectorAll('.swiper-container, .swiper').forEach((el) => {
    // si ya existe una instancia, destrúyela
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    const swiper = new Swiper(el, {
      loop: true,
      slidesPerView: 1.1,
      spaceBetween: 16,
      speed: 600,
      grabCursor: true,

      // clave cuando el slider está dentro de layouts dinámicos
      observer: true,
      observeParents: true,

      breakpoints: {
        640: { slidesPerView: 2.2 },
        992: { slidesPerView: 3.2 },
        1200: { slidesPerView: 4 }
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });

    setTimeout(() => swiper.update(), 150);
  });
});
